import { render, staticRenderFns } from "./ViewUserPosts.vue?vue&type=template&id=04a549b0&"
import script from "./ViewUserPosts.vue?vue&type=script&lang=js&"
export * from "./ViewUserPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports